import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const NDCLOOKUP_REQUEST = 'NDCLOOKUP_REQUEST';
export const NDCLOOKUP_SUCCESS = 'NDCLOOKUP_SUCCESS';
export const NDCLOOKUP_FAILURE = 'NDCLOOKUP_FAILURE';

export const NDC_REQUEST = 'NDC_REQUEST';
export const NDC_SUCCESS = 'NDC_SUCCESS';
export const NDC_FAILURE = 'NDC_FAILURE';

export const NDC_UPDATE_REQUEST = 'NDC_UPDATE_REQUEST';
export const NDC_UPDATE_SUCCESS = 'NDC_UPDATE_SUCCESS';
export const NDC_UPDATE_FAILURE = 'NDC_UPDATE_FAILURE';

export function requestNdcLookup(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/ndc/search?${query}`,
      method: 'GET',
      types: ['NDCLOOKUP_REQUEST', 'NDCLOOKUP_SUCCESS', 'NDCLOOKUP_FAILURE'],
    }
  };
}

export function requestNdc(productId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/ndc/${productId}?${query}`,
      method: 'GET',
      types: ["NDC_REQUEST", "NDC_SUCCESS", "NDC_FAILURE"]
    }
  }
}

export function updateNdc(ndc, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/ndc/${ndc.productId}?${query}`,
      method: 'POST',
      body: JSON.stringify(ndc),
      types: ["NDC_UPDATE_REQUEST", "NDC_UPDATE_SUCCESS", "NDC_UPDATE_FAILURE"]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/ndc-lookup/NdcLookupActions.js